<template>
    <div class="Seguro-Colectivo-Salud">
        <div class="title">
                <span>Seguros</span>
                <h1>Empresariales</h1>
                <div id="contactForm">
                    <label for="">Conoce más sobre soluciones de seguros</label>
                    <div id="hubcontactForm"></div>
                </div>
        </div>
        <div class="info">
                <h1>Seguro Multirriesgo Corporativo</h1>
                <p>Para proteger la estabilidad de su negocio, invierta en la seguridad de los bienes que permiten el adecuado
                funcionamiento de su empresa.
                </p>
        </div>
        <div class="services">
            <center>
                <h1>Con este seguro su empresa puede:</h1>
                <div v-for="(slide, i) in slides" :key="i">
                    <div v-for="(service, y) in slide.service" :key="y">
                        <div class="service-img">
                            <div>
                                <img :src="service.img" alt="">
                                <p v-html="service.text"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </center>
        </div>
        <div class="texto">
            <center class="box">
                <p>Los bienes de una empresa son parte de su patrimonio. Estos son esenciales para la realización de sus actividades productivas, por lo
                que gestionar los riesgos que pueden afectarlos no da espera.
                <br>
                <br>
                Con el Seguro Multirriesgo Corporativo le ayudamos a brindarle tranquilidad a sus empleados, clientes y proveedores. Su negocio obtendrá el
                mejor respaldo en situaciones que podrían afectar su funcionamiento, como el hurto, los daños que generen fenómenos geológicos y
                climáticos, entre otras.
                <br>
                <br>
                Invertir en la protección es fortalecer la permanencia de su empresa en el tiempo.<span> ¡Permítanos asesorarlo!</span></p>
            </center>
        </div>
        <div class="cubrimos">
            <div class="service" v-for="(service, i) in services" :key="i">
                <div v-if="service.type">
                    <div class="imgbox">
                        <img :src="service.img" alt="">
                    </div>
                    <div class="box">
                        <h1>{{service.label}}</h1>
                        <p>{{service.p2}}</p>
                        <div v-for="(p, y) in service.p" :key="y">
                            <div><font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/><p v-html="p"></p></div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="imgbox right">
                        <img :src="service.img" alt="">
                    </div>
                    <div class="box2">
                        <h1>{{service.label}}</h1>
                        <div v-for="(p, y) in service.p" :key="y">
                            <div><font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/><p v-html="p"></p></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="connect">
            <img src="@/assets/bg-llamado-accion.webp" alt="">
            <h1>¿Cuál es el valor asegurable?</h1>
            <p>Este estará sujeto a la reposición o al reemplazo de todos los activos. Para los bienes muebles, la reposición se hará por lo que cueste un
            producto u objeto nuevo de la misma clase. En caso de ser un inmueble, el valor de reposición o reemplazo será el dinero necesario para
            repararlo o reconstruirlo.</p>
        </div>
        <Aliados/>
    </div>
</template>

<script>
import Aliados from '../../utilitis/aliados'

export default {
    name: 'Multiriesgo-corporativo',
    metaInfo() {
        return {
            title: 'Seguro Multirriesgo Corporativo',
            titleTemplate: '%s | Interseguros',
            meta: [{
                vmid: 'description',
                name: 'description',
                content: 'Para proteger la estabilidad de su negocio, invierta en la seguridad de los bienes que permiten el adecuado funcionamiento de su empresa.'
            },
            {
                vmid: 'keywords',
                name: 'keywords',
                content: 'Asesor en riesgos laborales, intermediación ARL, Control de ARL, Seguros ARL, Administradora de Riesgo Laborales, Seguros Generales, Seguros Empresariales, Seguros Personales'
            },
            {
                vmid: 'image',
                name: 'image',
                content: require('@/assets/logo/logo.webp')
            },
            {
                vmid: 'robots',
                name: 'robots',
                content: 'index, follow'
            },
            {
                vmid: 'twitter:card',
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                vmid: 'twitter:title',
                name: 'twitter:title',
                content: 'Interseguros'
            },
            {
                vmid: 'twitter:site',
                name: 'twitter:site',
                content: '@Interseguros'
            },
            {
                vmid: 'twitter:description',
                name: 'twitter:description',
                content: 'Recibe asesoría para cotizar y contratar diferentes tipos de seguros para empresas.'
            },
            {
                vmid: 'twitter:image',
                name: 'twitter:image',
                content: require('@/assets/image-people.png')
            }]
        }
    },
    components: {
        Aliados
    },
    data() {
        return {
            services: [
                {
                    type: true,
                    img: require('@/assets/Multiriesgo-corporativo/4.png'),
                    label: '¿Qué cubrimos?',
                    p: [
                        '<span>Daños materiales:</span> indemnizamos los daños o las pérdidas materiales imprevistas y accidentales que sufra su edificio, muebles, enseres, escritorios, sillas, maquinaria, equipos de cómputo e impresión y utensilios de oficina, así como mercancías y materias primas.',
                        '<span>Lucro cesante:</span> asumiremos la disminución de los ingresos de su empresa cuando se vean afectados por daños imprevistos y accidentales de los bienes asegurados.',
                        '<span>Incremento de costos o gastos de funcionamiento:</span> cubrimos los costos o gastos en los que deba incurrir para evitar o reducir la disminución de los ingresos normales de su negocio a causa de un daño cubierto por este seguro.'
                    ]
                },
                {
                    type: false,
                    img: require('@/assets/Multiriesgo-corporativo/5.png'),
                    label: '¿Qué no cubrimos?',
                    p: [
                        'Guerra, invasión, actos de enemigos extranjeros, hostilidades u operaciones bélicas (exista o no declaración de guerra).',
                        'Despojo permanente o temporal producto de cualquier confiscación, apropiación o embargo hecho por una autoridad legalmente constituida.',
                        'Actos malintencionados, como el uso de explosivos, por parte de personas distintas o pertenecientes al personal de su empresa.',
                        'Órdenes o actos de autoridades competentes (embargos, secuestros, sanciones civiles, allanamientos, decomisos y confiscaciones).'
                    ]
                },
                {
                    type: true,
                    img: require('@/assets/Multiriesgo-corporativo/6.png'),
                    label: '¿Qué bienes se pueden asegurar?',
                    p2: 'Proteja los bienes muebles (objetos que pueden trasladarse a otro lugar) e inmuebles (casas, edificios y, en general, bienes raíces) de su organización.',
                    p: [
                        '<span>Edificios: </span> construcciones fijas, muros de contención, chimeneas, avisos, vallas, tanques, patios y cimentaciones. No se incluyen el terreno ni el suelo de apoyo, así como el costo de las excavaciones, preparaciones del terreno y honorarios del diseño.',
                        '<span>Contenidos: </span>muebles, enseres, estanterías, escritorios, sillas y utensilios de oficina.',
                        '<span>Existencias: </span>mercancías, materias primas, material de empaque y productos elaborados por su empresa o que están en desarrollo.',
                        '<span>Maquinaria y equipos: </span>aparatos cuyo funcionamiento sea de naturaleza eléctrica, mecánica o electromecánica.',
                        '<span>Dinero en efectivo y cheques: </span>dinero representado por billetes bancarios o monedas de cualquier país con cotización en la República de Colombia.'
                    ]
                },
                {
                    type: false,
                    img: require('@/assets/Multiriesgo-corporativo/7.png'),
                    label: '¿Qué bienes no aseguramos?',
                    p: [
                        'Cultivos, terrenos, plantaciones, siembras de cualquier tipo en crecimiento y madera almacenada.',
                        'Animales vivos.',
                        'Pieles, joyas, relojes, piedras preciosas o semipreciosas, oro y otros materiales preciosos.',
                        'Medallas, plata, murales y otros muebles que tengan valor artístico.',
                        'Algodón en pacas y semillas.',
                        'Vías públicas de acceso.',
                        'Carreteras, puentes, embalses, canales, túneles, muelles, murallas de mar, pozos, oleoductos y gasoductos.',
                        'Líneas de transmisión de energía.'
                    ]
                }
            ],
            slides: [
                {
                    service: [
                        {
                            text: 'Asegurar sus bienes ante posibles daños que pueden afectar sus actividades.',
                            img: require('@/assets/Multiriesgo-corporativo/1.png')
                        },
                        {
                            text: 'Tener apoyo económico si deja de percibir ingresos por riesgos cubiertos (lucro cesante)..',
                            img: require('@/assets/Multiriesgo-corporativo/2.png')
                        },
                        {
                            text: 'Proteger su patrimonio si pierde elementos de los que depende su solidez y continuidad.',
                            img: require('@/assets/Multiriesgo-corporativo/3.png')
                        }
                    ]
                }
            ]
        }
    },
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    },
    mounted() {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
    }
}
</script>

<style>
.cubrimos >.service > div > .box > div > div > p > span {
    font-weight: bold;
}
</style>

<style scoped>
    .title {
        background-image: url('../../../assets/servicios-empresariales-bg.png');
        padding: 200px 300px;
        color: #fff;
        background-position: center;
        background-repeat: no-repeat;
    }
    .title > span {
        font-family: 'JLI';
        font-size: 40px;
    }
    .title > h1 {
        font-family: 'JBD';
        font-size: 50px;
    }
    #contactForm {
        margin-top: -100px;
        font-family: 'JR';
        background-color: #fff;
        padding: 40px;
        position: absolute;
        border-radius: 10px;
        width: 400px;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        font-weight: bolder;
        right: 100px;
    }
    #contactForm > label {
        color: #65b24a;
        font-size: 24px;
        line-height: 25px;
    }
    .info {
        padding: 100px 0px;
    }
    .info > h1 {
        font-family: 'JBD';
        color: #65b24a;
        padding-left: 300px;
        font-size: 40px;
    }
    .info > p {
        font-family: 'JR';
        width: 60%;
        padding-left: 300px;
        margin-top: 10px;
        font-size: 18px;
    }
    .services {
        padding: 50px 300px;
        width: 100%;
    }
    .services > center {
        display: contents;
    }
    .services > center > div {
        display: inline-block;
        width: 100%;
    }
    .services > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 50px;
        font-size: 30px;
    }
    .services > center > div > div {
        display: inline-flex;
        width: 33.333333333%;
        float: left;
    }
    .services > center > div > div > .service-img {
        width: 100%;
    }
    .services > center > div > div > .service-img > div {
        position: relative;
        width: 100%;
        height: 100%;
        padding: auto;
        margin-bottom: 10px;
        transition: margin-top .5s ease-out 100ms;
    }
    .services > center > div > div > .service-img > div:hover {
        margin-top: -10px;
    }
    .services > center > div > div > .service-img > div >  img {
        width: 100%;
        height: auto;
    }
    .services > center > div > div > .service-img > div >  p {
        font-family: 'JR';
        font-size: 18px;
    }
    .texto {
        width: 100%;
        padding: 10px 300px;
    }
    .texto > .box-title {
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .texto > .box-title > h1 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .texto > .box {
        padding: 20px 20px;
        text-align: left;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        margin-bottom: 10px;
    }
    .texto > center > p {
        font-family: 'JR';
    }
    .texto > center > p > span{
        font-weight: bold;
    }
    .service {
        padding: 20px 300px;
        width: 100%;
    }
    .service > div {
        width: 100%;
        margin-top: 20px;
    }
    .service > div {
        width: 100%;
        display: flex;
    }
    .service > div > div > img {
        width: 350px;
        float: left;
    }
    .service > div > .imgbox {
        display: block;
        width: 350px;
        z-index: 99999;
    }
    .service > div > .box {
        margin-left: -300px;
        margin-top: 110px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 30px 30px 350px;
    }
    .service > div > .box > p{
        color: #65b24a;
        font-weight: bold;
    }
    .service > div > .box2 {
        margin-right: -300px;
        margin-top: 60px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 350px 100px 30px;
    }
    .service > div > .right{
        position: absolute;
        right: 15%;
    }
    .service > div > .box > h1 {
        position: relative;
        font-family: 'JBD';
        color:#2d4f98;
        margin-top: -120px;
        margin-bottom: 60px;
        text-align: left;
    }
    .service > div > .box > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .service > div > .box2 > h1 {
        position: relative;
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 10px;
        margin-top: -120px;
        text-align: right;
        margin-bottom: 60px;
    }
    .service > div > .box2 > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .facirclecheck-service {
        margin-right: 4px;
        margin-top: 4px;
        font-weight: bolder;
        color: #2d4f98;
        width: 15px;
        height: 15px;
        float: left;
    }
    .connect {
        background: -prefix-linear-gradient(left, #2d4f98, #65b24a);
        background: linear-gradient(to right, #2d4f98 30%, #65b24a);
        height: 200px;
        width: 100%;
    }
    .connect > img {
        position: absolute;
        height: 200px;
        width: 380px;
        right: 0;
        object-fit: cover;
        object-position: 75px -70px;
    }
    .connect > h1 {
        font-family: 'JBD';
        padding-top: 50px;
        padding-left: 200px;
        color: #65b24a;
    }
    .connect > p{
        font-family: 'JR';
        padding-left: 200px;
        width: 80%;
        color: #fff;
        font-size: 22px;
        line-height: 25px;
    }
    @media (max-width: 1500px) {
        .title {
            padding: 200px 200px;
        }
        .info > h1 {
            padding-left: 200px;
        }
        .info > p {
            padding-left: 200px;
        }
        .services {
            padding: 50px 200px;
            width: 100%;
        }
    }
    @media (max-width: 1400px) {
        .title {
            padding: 200px 100px;
        }
        .info > h1 {
            padding-left: 100px;
        }
        .info > p {
            padding-left: 100px;
        }
        .services {
            padding: 50px 100px;
            width: 100%;
        }
        .service {
            padding: 20px 150px;
            width: 100%;
        }
    }
    @media (max-width: 1300px) {
        .info > h1 {
            font-size: 30px;
        }
        .info > p {
            width: 50%;
        }
        .services {
            padding: 50px 50px;
            width: 100%;
        }
        .texto {
            width: 100%;
            padding: 10px 200px;
        }
    }
    @media (max-width: 1200px) {
        .service {
            padding: 20px 75px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 10%;
        }
    }
    @media (max-width: 1100px) {
        .service {
            padding: 20px 50px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 5%;
        }
        .connect > h1 {
            padding-top: 10px;
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        .connect > p{
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        #contactForm {
            margin-top: -100px;
            right: 50px;
        }
    }
    @media (max-width: 1000px) {
        .title {
            padding: 50px 0px;
            height: 400px;
            text-align: center;
        }
        #contactForm {
            margin-top: 10px;
            left: 0;
            right: 0;
            margin: auto;
        }
        .info {
            padding-top: 400px;
            width: 100%;
            text-align: center;
        }
        .info > h1 {
            padding: 10px;
        }
        .info > p {
            width: 100%;
            text-align: center;
            padding: 10px;
        }
        .texto {
            width: 100%;
            padding: 10px 100px;
        }
        .services {
            padding: 0px 50px;
        }
        .service {
            padding: 20px 25px;
            width: 100%;
        }
        .connect > h1 {
            padding-left: 50px;
            font-size: 30px;
        }
        .connect > p{
            padding-left: 50px;
            font-size: 18px;
        }
    }
    @media (max-width: 900px) {
        .colectivo > center > div {
            display: block;
        }
    }
    @media (max-width: 800px) {
        .services > center > div > div {
            display: block;
            width: 60%;
            float: none;
        }
        .service > div {
            display: grid;
        }
        .service > div > .box{
            margin-left: 0px;
            margin-top: 0px;
            width: 100%;
            padding: 30px 30px 30px 30px;
        }
        .service > div > .box2 {
            margin-right: 0px;
            margin-top: 0px;
            background-color: #fff;
            width: 100%;
            padding: 30px 30px 100px 30px;
        }
        .service > div > .imgbox {
            display: block;
            width: 100%;
            display: flex;
            justify-content: center;
        }
        .service > div > .imgbox > img{
            width: 250px;
            margin: auto;
        }
        .service > div > .right{
            position: relative;
            right: 0px;
        }
        .service > div > .box2 > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .service > div > .box > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
    }
    @media (max-width: 700px) {
        .texto {
            width: 100%;
            padding: 10px 50px;
        }
    }
    @media (max-width: 600px) {
        .connect > h1 {
            font-size: 18px;
        }
        .connect > p{
            font-size: 18px;
            width: 100%;
        }
        .services > center > div > div {
            width: 70%;
        }
    }
    @media (max-width: 500px) {
        .texto > .box-title > h1 {
            font-size: 30px;
        }
        #contactForm {
            width: 300px;
        }
        .connect > h1 {
            padding-left: 25px;
        }
        .connect > p{
            padding-left: 25px;
        }
        .services > center > div > div {
            width: 80%;
        }
    }
    @media (max-width: 400px) {
        .services > center > div > div {
            width: 90%;
        }
        .connect > p{
            padding-left: 5px;
            font-size: 16px;
            line-height: 19px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Servicios/ServiciosEmpresas/MultirriesgoCorporativo.vue